import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const costingManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all costings
    getAllCostings: builder.query({
      query: () => ({
        url: "qwikITCosting/",
        method: "GET",
      }),
      providesTags: ["costings"],
      transformResponse: response => response,
    }),

    // Get a single costing by ID
    getCosting: builder.query({
      query: id => ({
        url: `qwikITCosting/${id}/`,
        method: "GET",
      }),
      providesTags: ["costings"],
      transformResponse: response => response,
    }),

    // Create a new costing
    createCosting: builder.mutation({
      query: data => ({
        url: "qwikITCosting/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["costings"],
      transformResponse: response => {
        toast.success("Costing added successfully");
        return response;
      },
    }),

    // Update costing
    updateCosting: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `qwikITCosting/${id}/`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["costings"],
      transformResponse: response => {
        toast.success("Costing updated successfully");
        return response;
      },
    }),

    // Delete costing
    deleteCosting: builder.mutation({
      query: id => ({
        url: `qwikITCosting/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["costings"],
      transformResponse: response => {
        toast.success("Costing deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllCostingsQuery,
  useGetCostingQuery,
  useCreateCostingMutation,
  useUpdateCostingMutation,
  useDeleteCostingMutation,
} = costingManagementApi;